import { BulkAction } from 'labstep-web/components/Entity/Search/BulkActions';
import { Filter } from 'labstep-web/constants/filters';

export const filters = [
  Filter.date_range,
  Filter.tag,
  Filter.deleted,
  Filter.purchase_order_status,
];

export const bulkActions = [BulkAction.delete];
